var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.9994C12.6486 20.3335 14.6136 20.3335 15.5955 18.9994L26.6362 3.99895C27.8492 2.35091 26.6943 1.94553e-06 24.6718 2.12235e-06L2.59046 2.14541e-06C0.56789 2.32223e-06 -0.586954 2.35091 0.62604 3.99896L11.6667 18.9994Z",
    fill: "#78E395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/top-arrow.caad7dbaf88acf72d7af3fdd971b3285.svg";
export { ForwardRef as ReactComponent };